import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { registerEstablishment, updateEstablishment } from "./thunks";
import { toast } from "react-toastify";
import { RegisterForm } from "@/types/register";

interface RegisterResponse {
  user: Omit<RegisterForm, "confirmPassword">;
  token?: string;
}

interface RegisterState {
  loading: boolean;
  error: string | null;
  user: Omit<RegisterForm, "confirmPassword"> | null;
  token?: string;
}

const initialState: RegisterState = {
  loading: false,
  error: null,
  user: null,
  token: undefined,
};

const registerSlice = createSlice({
  name: "register",
  initialState,
  reducers: {
    clearRegister: (state) => {
      state.user = null;
      state.error = null;
      state.loading = false;
      state.token = undefined;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(registerEstablishment.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        registerEstablishment.fulfilled,
        (state, action: PayloadAction<RegisterResponse>) => {
          state.loading = false;
          state.user = action.payload.user;
          state.token = action.payload.token;
          // Toast será gerenciado pelo hook para melhor controle do fluxo
        },
      )
      .addCase(registerEstablishment.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as { error: string }).error;
        toast.error(
          (action.payload as { error: string }).error ||
            "Erro ao cadastrar usuário",
        );
      })

      // Update
      .addCase(updateEstablishment.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        updateEstablishment.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.loading = false;
          state.user = action.payload.user;
          toast.success("Estabelecimento atualizado com sucesso!");
        },
      )
      .addCase(updateEstablishment.rejected, (state, action) => {
        state.error = (action.payload as { error: string }).error;
        state.loading = false;
        console.log("error", state.error);
        toast.error("Error");
      });
  },
});

export default registerSlice.reducer;
